// Historical snapshot: the 2026 camp program exactly as it ran
// (teens Jul 7-8, kids Jul 9-10, joint final Sat Jul 11).
// Rendered by PreviousYear.tsx as the public archive. Do not edit.

import type { CampProgram } from './programData';

export const campPrograms2026: CampProgram[] = [
  {
    id: 'teens',
    label: 'Jaunieši 14+',
    ageLabel: '14+ gadi',
    dates: '7.–8. jūlijs',
    days: [
      {
        date: '7. jūlijs',
        day: 'Otrdiena',
        activities: [
          { time: '10:30', title: 'Reģistrācija', description: 'Dalībnieku reģistrācija', type: 'day-camp', icon: 'registration' },
          { time: '10:30', title: 'Iepazīšanās ar grupām', description: 'Spēles un iepazīšanās savā grupā', type: 'day-camp', icon: 'groups' },
          { time: '11:30', title: 'Informācija', description: 'Dienas atklāšana un informācija', type: 'day-camp', icon: 'info' },
          { time: '12:00', title: 'Kopīgā spēle', description: 'Komandu spēles ar punktiem', type: 'day-camp', icon: 'game' },
          { time: '13:20', title: 'Uzkodas', description: 'Augļi, bulciņas un sula', type: 'day-camp', icon: 'snacks' },
          { time: '14:20', title: 'Pasākums teltī ar konkursiem', description: 'Programma un konkursi lielajā teltī', type: 'day-camp', icon: 'tent' },
          { time: '15:20', title: 'Aktivitātes stadionā', description: 'Volejbols, futbols, loka šaušana un citas aktivitātes', type: 'day-camp', icon: 'stadium' },
          { time: '17:30', title: 'Vakariņas no grila', description: 'Burgeri un salāti', type: 'day-camp', icon: 'dinner' },
          { time: '19:00', title: 'Vakara pasākums teltī ar konkursiem', description: 'Vakara programma un mini balvas (līdz 20:00)', type: 'day-camp', icon: 'evening' },
        ],
      },
      {
        date: '8. jūlijs',
        day: 'Trešdiena',
        activities: [
          { time: '11:00', title: 'Laiks grupās', description: 'Diena sākas kopā ar savu grupu', type: 'day-camp', icon: 'groups' },
          { time: '11:30', title: 'Informācija', description: 'Dienas atklāšana un informācija', type: 'day-camp', icon: 'info' },
          { time: '12:00', title: 'Kopīgā spēle', description: 'Capture the Flag un citas komandu spēles', type: 'day-camp', icon: 'flag' },
          { time: '13:30', title: 'Uzkodas', description: 'Augļi, bulciņas un sula', type: 'day-camp', icon: 'snacks' },
          { time: '14:30', title: 'Pasākums teltī ar konkursiem', description: 'Programma un konkursi lielajā teltī', type: 'day-camp', icon: 'tent' },
          { time: '15:30', title: 'Aktivitātes stadionā', description: 'Volejbols, futbols un citas aktivitātes', type: 'day-camp', icon: 'stadium' },
          { time: '17:30', title: 'Vakariņas no grila', description: 'Šašliks un salāti', type: 'day-camp', icon: 'dinner' },
          { time: '19:00', title: 'Vakara pasākums teltī ar konkursiem', description: 'Vakara programma un mini balvas (līdz 20:00)', type: 'day-camp', icon: 'evening' },
        ],
      },
    ],
  },
  {
    id: 'kids',
    label: 'Bērni līdz 13 g.',
    ageLabel: 'līdz 13 gadiem',
    dates: '9.–10. jūlijs',
    days: [
      {
        date: '9. jūlijs',
        day: 'Ceturtdiena',
        activities: [
          { time: '10:30', title: 'Reģistrācija', description: 'Dalībnieku reģistrācija', type: 'day-camp', icon: 'registration' },
          { time: '10:30', title: 'Iepazīšanās ar grupām', description: 'Spēles un iepazīšanās savā grupā', type: 'day-camp', icon: 'groups' },
          { time: '11:30', title: 'Informācija', description: 'Dienas atklāšana un informācija', type: 'day-camp', icon: 'info' },
          { time: '12:00', title: 'Uzkodas', description: 'Augļi un bulciņas', type: 'day-camp', icon: 'snacks' },
          { time: '13:00', title: 'Aktivitātes stadionā', description: 'Spēles, sports un radošās darbnīcas', type: 'day-camp', icon: 'stadium' },
          { time: '14:30', title: 'Pasākums teltī ar konkursiem', description: 'Programma un konkursi lielajā teltī', type: 'day-camp', icon: 'tent' },
          { time: '16:00', title: 'Aktivitātes stadionā', description: 'Spēles un aktivitātes turpinās', type: 'day-camp', icon: 'stadium' },
          { time: '17:30', title: 'Vakariņas no grila', description: 'Burgeri un salāti', type: 'day-camp', icon: 'dinner' },
          { time: '18:30', title: 'Vakara pasākums teltī ar konkursiem', description: 'Vakara programma un mini balvas (līdz 20:00)', type: 'day-camp', icon: 'evening' },
        ],
      },
      {
        date: '10. jūlijs',
        day: 'Piektdiena',
        activities: [
          { time: '11:00', title: 'Laiks grupās', description: 'Diena sākas kopā ar savu grupu', type: 'day-camp', icon: 'groups' },
          { time: '11:30', title: 'Informācija', description: 'Dienas atklāšana un informācija', type: 'day-camp', icon: 'info' },
          { time: '12:00', title: 'Uzkodas', description: 'Augļi un bulciņas', type: 'day-camp', icon: 'snacks' },
          { time: '13:00', title: 'Aktivitātes stadionā', description: 'Spēles, sports un radošās darbnīcas', type: 'day-camp', icon: 'stadium' },
          { time: '14:30', title: 'Pasākums teltī ar konkursiem', description: 'Programma un konkursi lielajā teltī', type: 'day-camp', icon: 'tent' },
          { time: '15:30', title: 'Aktivitātes stadionā', description: 'Spēles un aktivitātes turpinās', type: 'day-camp', icon: 'stadium' },
          { time: '17:30', title: 'Vakariņas no grila', description: 'Šašliks un salāti', type: 'day-camp', icon: 'dinner' },
          { time: '19:00', title: 'Vakara pasākums teltī ar konkursiem', description: 'Vakara programma un mini balvas (līdz 20:00)', type: 'day-camp', icon: 'evening' },
        ],
      },
    ],
  },
];
